import { types } from "../../types/types";

const initialState = {
  bills: []
}

export const RegisterActivateBillReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.registerBill:
      return{
        ...state,
        bills: [ ...action.payload ]
      }
      
    default:
      return state;
  }
}
